import React from 'react';
import { Global } from '@emotion/react';
import { cssReset } from 'ui_system/token_auth/styles_root';
import { Logo } from './logo';
import { Container, H1, BareHR, BodyText, RedLink } from './PrivacyStyles';

const PrivacyVerificationFailed = () => (
  <React.Fragment>
    <Global styles={cssReset({})} />
    <Logo />
    <BareHR />
    <Container>
      <H1>Oops... something went wrong!</H1>
      <BodyText>
        Your request could not be submitted. Please{' '}
        <RedLink href="/ccpa">submit a new request</RedLink>.
      </BodyText>
    </Container>
  </React.Fragment>
);

export default PrivacyVerificationFailed;
